module.exports = __webpack_public_path__ + "img/notevayas.6412434f.png";